module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/fidelity@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/fidelity@3x.png
// module id = 1170
// module chunks = 0